import { SectionSegment } from "@utils/questionnaire/progress/sectionProgress";

import { Bar, Fill, Rail, SectionName, SegmentName, SegmentTrack, Segments } from "./styles";

interface QuestionnaireProgressProps {
  segments: SectionSegment[];
  // Replaces the current section's name when no section is current.
  subheader?: string;
}

const currentSectionNameOf = (segments: SectionSegment[]) =>
  segments.find(({ isCurrent }) => isCurrent)?.name ?? "";

export const QuestionnaireProgress = ({ segments, subheader }: QuestionnaireProgressProps) => {
  const hasCurrentSection = segments.some(({ isCurrent }) => isCurrent);
  const shownName = hasCurrentSection ? currentSectionNameOf(segments) : (subheader ?? "");

  return (
    <Bar
      role="progressbar"
      aria-label="Questionnaire progress"
      aria-valuetext={shownName}
      data-testid="questionnaire-progress"
    >
      <Segments>
        {segments.map((segment) => (
          <SegmentTrack key={segment.section} data-testid="segment-track">
            <Rail>
              <Fill $ratio={segment.fillRatio} data-testid="segment-fill" />
            </Rail>
            {hasCurrentSection && (
              <SegmentName $isCurrent={segment.isCurrent} data-testid="segment-name">
                {segment.name}
              </SegmentName>
            )}
          </SegmentTrack>
        ))}
      </Segments>
      <SectionName $isShownOnWide={!hasCurrentSection} data-testid="section-name">
        {shownName}
      </SectionName>
    </Bar>
  );
};
